import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Spinner,
} from "@fluentui/react-components";
import { DeleteDismissFilled } from "@fluentui/react-icons";
import { toast } from "components/FluentToast";
import { VSpace } from "components/Spacer";
import React from "react";
import { useTranslation } from "react-i18next";
import { useInsurerReportsStore } from "store/InsurerReportsStore";

export const DeleteInsurerReportDialog = () => {
  const [
    { deleteInsurerReportDialog, deleteInsurerReportStatus },
    {
      setInsurerReportsStoreValue,
      setInsurerReportsStoreValues,
      deleteInsurerReport,
      removeInsurerReports,
    },
  ] = useInsurerReportsStore();

  const isLoading = deleteInsurerReportStatus === "loading";
  const { t } = useTranslation();

  return (
    <Dialog open={deleteInsurerReportDialog.isOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{t("pct.deleteInsurerReport.label")}</DialogTitle>
          <DialogContent>
            {t("pct.deleteInsurerReportConfirm.label")}
            <VSpace height={20} />
          </DialogContent>
          <DialogActions>
            <Button
              appearance="secondary"
              disabled={isLoading}
              onClick={() => {
                setInsurerReportsStoreValue("deleteInsurerReportDialog", {
                  isOpen: false,
                  insurerReportId: null,
                });
              }}
            >
              {t("pct.close.label")}
            </Button>
            <Button
              data-help="insurer-reports-delete-confirm"
              appearance="primary"
              disabled={isLoading}
              icon={
                isLoading ? (
                  <Spinner size="tiny" />
                ) : (
                  <DeleteDismissFilled fontSize={16} />
                )
              }
              onClick={() => {
                deleteInsurerReport(
                  {
                    insurerReportId:
                      deleteInsurerReportDialog.insurerReportId,
                  },
                  (deletedInsurerReports) => {
                    setInsurerReportsStoreValues({
                      deleteInsurerReportDialog: {
                        isOpen: false,
                        insurerReportId: null,
                      },
                    });
                    toast.success(t("greco.success"));
                    // every report imported from the same document is deleted
                    // together and returned, so only those rows are dropped
                    removeInsurerReports(deletedInsurerReports);
                  }
                );
              }}
            >
              {t("pct.delete.label")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
